import React from "react";
import { Row, Button, Tooltip, Icon, Checkbox } from "antd";
import { CheckboxChangeEvent } from "antd/lib/checkbox";

interface ButtonsGroupProps {
    handleNew: () => void;
    exportList: (type: "pdf" | "xls") => void;
    toogleShowDeletedRecords: (value: boolean) => void;
}

export const ButtonsGroup = ({ handleNew, exportList, toogleShowDeletedRecords }: ButtonsGroupProps) => {
    function handleChangeShowDelete(event: CheckboxChangeEvent) {
        const isChecked = event.target.checked;
        toogleShowDeletedRecords(isChecked ?? false);
    }
    return (
        <Row>
            <Button onClick={handleNew} type="primary" style={{ float: "right", marginLeft: 8, marginBottom: 16 }}>
                <Icon type="plus" />
                Inserir
            </Button>
            <Tooltip title="Exportar para pdf">
                <Button
                    onClick={() => exportList("pdf")}
                    icon="file-pdf"
                    size="default"
                    style={{
                        marginBottom: 16,
                        marginLeft: 8,
                        float: "right",
                        color: "#fa541c",
                    }}
                />
            </Tooltip>
            <Tooltip title="Exportar para excel">
                <Button
                    onClick={() => exportList("xls")}
                    icon="file-excel"
                    size="default"
                    style={{
                        marginBottom: 16,
                        marginLeft: 8,
                        float: "right",
                        color: "#237804",
                    }}
                />
            </Tooltip>
            <Checkbox onChange={handleChangeShowDelete}>Mostrar registos eliminados</Checkbox>
        </Row>
    );
};
